import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../../axiosAuth";
import { SCHOOL_INSTALLMENT_RECEIPT_DETAILS_BY_INSTALLMENT_ID } from "../../../apiRoutes";

export interface ReceiptData {
  _id: string;
  receiptId: string;
  generationDate: string;
  generatedBy: string;
  generatedByProfile:any;
}

export interface ReceiptResponse {
  data: ReceiptData;
  message: string;
  success: boolean;
}

export const useGetReceiptByInstallmentIdQuery = (
  installmentId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["receipt", installmentId],
    queryFn: async (): Promise<ReceiptResponse> => {
      const response = await axiosAuth.get(`${SCHOOL_INSTALLMENT_RECEIPT_DETAILS_BY_INSTALLMENT_ID}${installmentId}/`);
      return response.data;
    },
    enabled: !!installmentId && (options?.enabled ?? true),
  });
};
